/**
 * Parses the pathname of a profile URL into a datatype and an Object ID.
 * If the pathname is not part of a valid profile URL, it will return undefined.
 *
 * @param path The pathname of a given URL
 *
 * @returns An object containing the datatype and Object ID, or undefined if the URL is not a valid profile URL.
 */
export const parsePath = (path: string): { dataType: string; profileId?: number } | undefined => {
    if (path.includes("/search/")) {
        return { dataType: "search" }
    }

    try {
        const pattern = /^\/(?<dataType>[a-zA-Z]+)\/(?<id>\d+)\/?.*$/
        const { groups } = path.match(pattern)

        return {
            dataType: groups.dataType,
            profileId: parseInt(groups.id),
        }
    } catch {
        return {
            dataType: undefined,
        }
    }
}

/**
 * Returns the icon associated with a given datatype.
 *
 * @param dataType The datatype used in the Profile URL
 *
 * @returns The icon associated with the datatype or undefined
 */
export const getIcon = (dataType: string): string | undefined => {
    // TODO: This should be able to lookup the QDT by the profile key, but many QDTs can share the same key
    // eg: Tweets, Press Statements, Committee Hearings are all /document/
    const { QuorumDataType } = DjangIO.app.models

    switch (dataType) {
        case "search":
            return "search"

        case "amendment":
            return QuorumDataType.amendment.fa5_icon
        case "bill":
            return QuorumDataType.bill.fa5_icon
        case "committee":
            return QuorumDataType.committee.fa5_icon
        case "contact":
            return QuorumDataType.supporter.fa5_icon
        case "document":
            return QuorumDataType.document.fa5_icon
        case "event":
            return QuorumDataType.event.fa5_icon
        case "official":
            return QuorumDataType.person.fa5_icon
        case "organization":
            return QuorumDataType.organization.fa5_icon
        case "regulation":
            return QuorumDataType.regulation.fa5_icon
        case "vote":
            return QuorumDataType.vote.fa5_icon

        default:
            return
    }
}
